module.exports = __webpack_public_path__ + "static/media/photo12.6040b685.jpg";